<template>
  <div class="row">
    <LmSuperPowerSelect
      class="col-12 col-lg-6"
      :data="lmSuperPowerSelects.oficinas.selectOptions"
      :tbColumns="lmSuperPowerSelects.oficinas.tbColumns"
      label="Nombre área interna"
      title="Nombre área interna"
      placeholder="Nombre área interna"
      @values="updateOficinaAreaInterna"
      :v="validation.oficinaAreaInterna"
      :model="sanitizeModel(form.idOficinaAreaInterna)"
      :disabled="isOnEditMode"
    />
    <LmTextInput
      class="col-12 col-lg-6"
      v-model="form.notaAreaInterna"
      :v="validation.notaAreaInterna"
      label="Nota Interna"
      placeholder="Número de nota interna"
      :disabled="isOnEditMode"
    />
  </div>
</template>

<script>
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
export default {
  mixins: [lmSuperPowerSelectHelper],
  data () {
    return {
      lmSuperPowerSelects: {
        oficinas: {
          selectOptions: [],
          tbColumns: [
            { title: 'Calle', data: 'name' }
          ]
        }
      }
    }
  },
  components: {
    LmSuperPowerSelect,
    LmTextInput
  },
  props: {
    validation: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateOficinaAreaInterna (values) {
      let value = values[0]
      this.form.oficinaAreaInterna = value ? value.name : ''
      this.form.idOficinaAreaInterna = value ? value.id : ''
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    }
  },
  mounted () {
    this.getAllLmSuperPowerSelectOptions(
      [
        { name: 'oficinas',
          obj: {
            path: 'oficinas/predictivo/',
            total: 1000
          }
        }
      ]
    ).then(response => {
      response.forEach(async element => {
        const e = await element
        this.lmSuperPowerSelects[e.name].selectOptions = e.data
      })
    })
  }
}
</script>
